import MUICheck from '@mui/icons-material/Check'

export const CheckIcon = MUICheck
